<template>
    <el-card class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
            <span>产品所属的品类路径及排名趋势</span>
        </div> 
        <div style="display: flex;min-width:1100px;">
            <div id="ranking" style="width:500px;height:400px;"></div>
            <div id="diagram" style="height:400px;flex: 1"></div>
        </div>
    </el-card>
</template>

<script>
import * as echarts from "echarts";
export default {
    data() {
        return {
            myChart: null,
            myChartRanking: null
        };
    },
    mounted() {
        this.myChartRanking = echarts.init(document.getElementById("ranking"));
        this.getDataDiagram();
    },
    methods: {
        screenWidth() {
            this.myChart.resize();
        },
        getData(date_name) {
            let date = [
                "boys（2级）",
                "girls（2级）",
                "men（2级）",
                "jewelry（3级）",
                "clothing（1级）",
                "jewelrys（3级）",
                "chains（1级）",
                "pendants（3级）",
                "women（2级）",
                "necklaces（3级）",
                "shoes（3级）",
                "coins（3级）",
                "penaasd（3级）"
            ];
            let data = [];
            for (let i = 0; i < date.length; i++) {
                data.push(Math.floor(Math.random() * (1 - 1000000) + 1000000));
            }
            this.viewCharts(date_name, date, data);
        },
        getDataDiagram() {
            let oneDay = 24 * 3600 * 1000;
            let base = +new Date(2019, 9, 3);
            let dates = [];
            let datas = [];
            for (let i = 1; i < 200; i++) {
                let now = new Date((base += oneDay));
                dates.push([
                    [now.getFullYear(), now.getMonth() + 1, now.getDate()].join(
                        "-"
                    )
                ]);
                datas.push(Math.floor(Math.random() * (1 - 1000000) + 1000000));
            }
            this.viewChartsDiagram(dates, datas);
            this.getData(dates[dates.length - 1]);
        },
        viewChartsDiagram(date, data) {
            let that = this;
            this.myChart = echarts.init(document.getElementById("diagram"));
            let option = {
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    borderColor: "rgba(0, 0, 0, 0.6)",
                    textStyle: {
                        color: "rgb(255, 255, 255)"
                    },
                    axisPointer: {
                        animation: false
                    },
                    formatter: function(params) {
                        that.getData(params[0].axisValue);
                        var htmlStr = "";
                        for (var i = 0; i < params.length; i++) {
                            var param = params[i];
                            var xName = param.name;
                            var seriesName = param.seriesName;
                            var value = param.value;
                            var color = param.color;
                            if (i === 0) {
                                htmlStr += xName + "<br/>";
                            }
                            htmlStr += "<div>";
                            //为了保证和原来的效果一样，这里自己实现了一个点的效果
                            htmlStr +=
                                "<span style='margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:" +
                                color +
                                ";'></span>";
                            let str = value == null ? "--" : 1000000 - value;
                            htmlStr += seriesName + "：" + str;
                            htmlStr += "</div>";
                        }
                        return htmlStr;
                    }
                },
                grid: {
                    left: "3%",
                    right: "8%",
                    bottom: "5%",
                    top: "5%"
                },
                xAxis: {
                    type: "category",
                    data: date,
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "rgb(240, 240, 240)",
                            type: "dashed"
                        }
                    },
                    axisLabel: {
                        show: true,
                        color: "rgb(60, 60, 60)"
                    }
                },
                yAxis: {
                    type: "value",
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed"
                        }
                    },
                    position: "right",
                    inverse: true
                },
                series: [
                    {
                        name: "价格：",
                        type: "line",
                        data: data,
                        showAllSymbol: false,
                        itemStyle: {
                            color: "rgb(204, 44, 35)"
                        },
                        lineStyle: {
                            color: "rgb(204, 44, 35)"
                        },
                        emphasis: {
                            lineStyle: {
                                width: 2
                            }
                        }
                    }
                ]
            };
            // 绘制图表
            this.myChart.setOption(option);
        },
        viewCharts(date_name, date, datas) {
            let data = JSON.parse(JSON.stringify(datas));
            let colorList = [];
            let index = 180 / data.length;
            let min = 1000000;
            for (let i = 0; i < data.length; i++) {
                if (data[i] != null) {
                    data[i] = 1000000 - data[i];
                    min = min < data[i] ? min : data[i];
                }
                colorList.unshift(
                    `rgb(245, ${index * i + 50}, ${index * i + 50})`
                );
            }
            let option = {
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    borderColor: "rgba(0, 0, 0, 0.6)",
                    textStyle: {
                        color: "rgb(255, 255, 255)"
                    },
                    axisPointer: {
                        animation: false
                    },
                    formatter: function(params) {
                        var htmlStr = "";
                        for (var i = 0; i < params.length; i++) {
                            var param = params[i];
                            var xName = param.name;
                            var seriesName = param.seriesName;
                            var value = param.value;
                            var color = param.color;
                            if (i === 0) {
                                htmlStr += xName + "<br/>";
                            }
                            htmlStr += "<div>";
                            //为了保证和原来的效果一样，这里自己实现了一个点的效果
                            htmlStr +=
                                "<span style='margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:" +
                                color +
                                ";'></span>";
                            let str = value == null ? "--" : 1000000 - value;
                            htmlStr += seriesName + "：" + str;
                            htmlStr += "</div>";
                        }
                        return htmlStr;
                    }
                },
                title: {
                    text: `排名日期： ${date_name}`,
                    textStyle: {
                        color: "rgb(80, 80, 80)",
                        fontStyle: "normal",
                        fontSize: "13",
                        lineHeight: 8
                    },
                    left: "2%"
                },
                grid: {
                    left: "3%",
                    right: "3%",
                    top: "5%",
                    bottom: "3%",
                    containLabel: true
                },
                xAxis: {
                    type: "value",
                    show: false,
                    min: min - min * 0.02
                    // inverse: true
                },
                yAxis: {
                    type: "category",
                    show: true,
                    data: date,
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "rgb(200, 200, 200)"
                        }
                    }
                },
                series: [
                    {
                        name: "brs",
                        type: "bar",
                        data: data,
                        showAllSymbol: false,
                        barWidth: 25,
                        itemStyle: {
                            color: function(params) {
                                return colorList[params.dataIndex];
                            },
                            borderRadius: [0, 4, 4, 0]
                        },
                        label: {
                            show: true,
                            position: "insideBottomLeft",
                            distance: 12,
                            align: "top",
                            offset: [40, 0],
                            verticalAlign: "middle",
                            rotate: 0,
                            formatter: function(params) {
                                return (
                                    params.name +
                                    "：" +
                                    (1000000 - params.value)
                                );
                            },
                            color: "rgb(65, 65, 65)",
                            fontSize: 12
                        },
                        lineStyle: {
                            color: "rgb(128, 157, 173)"
                        },
                        emphasis: {
                            lineStyle: {
                                width: 2
                            }
                        }
                    }
                ]
            };
            // 绘制图表
            this.myChartRanking.setOption(option);
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
</style>
